import { observable, action, makeObservable } from 'mobx';
import { getCollectList } from '@/api/myCollect';

class CollectStore {
    constructor() {
        makeObservable(this);
    }

    @observable page_num = 1;

    @observable page_size = 8;

    @observable template_id = '';

    @observable total = 0;

    @observable loading = true;

    @observable collect_list = [];

    @action
    setCollectList = (data) => {
        this.collect_list = data;
    };

    @action setState = (key, value, is_concat = false) => {
        if (is_concat) {
            this[key] = Object.assign(this[key], value);
        } else {
            this[key] = value;
        }
    };

    getList = async () => {
        this.setState('loading', true, false);
        const { data, total } = await getCollectList({
            page_num: this.page_num,
            page_size: this.page_size,
            template_id: this.template_id
        });
        this.setCollectList(data);
        this.setState('total', total);
        this.setState('loading', false, false);
    };
}

export default new CollectStore();
